import miscResx from 'Resx/Misc/Misc.resx';
import ajax from 'Js/api/lib/ajax';
import CurrencyDTO from '../DTO/CurrencyDTO';

export default class Currency extends CurrencyDTO {
    /**
     * @param {string|Object} object - объект с полями Code и Symbol или код по ISO 4217
     * @returns {Currency}
     */
    static parse(object) {
        if (typeof object == 'string') {
            const code = object;
            switch (code) {
                case 'USD':
                    return new Currency({ Code: 'USD', Symbol: '$' });
                case 'EUR':
                    return new Currency({ Code: 'EUR', Symbol: '€' });
                case 'GBP':
                    return new Currency({ Code: 'GBP', Symbol: '£' });
                case 'UAH':
                    return new Currency({ Code: 'UAH', Symbol: '₴' });
                case 'KZT':
                    return new Currency({ Code: 'KZT', Symbol: '₸' });
                case 'PLN':
                    return new Currency({ Code: 'PLN', Symbol: 'zł' });
                default:
                    return new Currency({ Code: code, Symbol: code });
            }
        } else if (object) {
            return new Currency(object);
        } else return null;
    }

    static get() {
        return ajax.get({
            url: '/api/v1/warehouse-currencies',
            dataType: 'json',
            process: es => es.map(e => new Currency(e))
        });
    }

    shortenedCurrencyName() {
        return (
            {
                UAH: miscResx.MiscShortenedCurrencyNameUAH
            }[this.code] ?? this.code
        );
    }
}
